module.exports = __webpack_public_path__ + "static/media/profyle-report.5ca2be86.jpg";